import { render, staticRenderFns } from "./SalarySet.vue?vue&type=template&id=13ae0470&scoped=true"
import script from "./SalarySet.vue?vue&type=script&lang=js"
export * from "./SalarySet.vue?vue&type=script&lang=js"
import style0 from "./SalarySet.vue?vue&type=style&index=0&id=13ae0470&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13ae0470",
  null
  
)

export default component.exports